module.exports = __webpack_public_path__ + "img/product_101.852e4c1.webp";